<template>
    <div>
        <h3 class="font-weight-regular mb-3 submenu-title">{{$t('turblattGegenbandseite')}}</h3>
        <v-radio-group v-model="leafSurfaceTypeOpeningSide" row mandatory>
            <template>
                <v-row>
                    <v-col cols="4" class="py-2"
                        v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_TOBERFL_GBS').values"
                        :key="index">
                        <v-radio :label="valueDefinition.description" :value="valueDefinition.value"
                            @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_GBS'), valueDefinition: valueDefinition });handleRadioSelect({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_GBS'), valueDefinition: valueDefinition })">
                        </v-radio>
                    </v-col>
                </v-row>
            </template>
        </v-radio-group>
        <v-row>
            <v-col md="6" sm="12">
                <div class="subtitle-2 mb-2">{{$t('turblattOberflache')}}</div>
                <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="doorSurfaceCharacteristicsDropDown" item-text="description"
                    :value="getRegisteredCharacteristicsValue(currentCharacteristicCode, doorLeafSurfaceContext).value"
                    @change="handleDoorSurfaceOptionSelect($event);">
                </v-select>

                <div class="body-2 pb-2" style="">
                    {{$t('sonderDekor')}}</div>
                <v-text-field  v-model="doorSurfaceSpecial"  :disabled="doorLeafSurfaceSpecialColorAvailability" dense outlined hide-details >
                </v-text-field>
               
            </v-col>
        </v-row>
    </div>
    <!-- <div>
        <h1 class="title">Turblatt Gegenbandseite</h1>
        <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
            <label v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_TOBERFL_GBS').values" :key="index" 
                @click="addCharacterisitc({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_GBS'), valueDefinition: valueDefinition });handleRadioSelect({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_BS'), valueDefinition: valueDefinition })" 
                :class="{ 'btn':true, 'btn-secondary':true, 'active': checkRadioValue(getCharacteristicAndValues('KTU_MM_TOBERFL_GBS').code, valueDefinition.value)}"
                >
                    <div class="radio-btn">
                        <span></span>
                    </div>
                    <input type="radio" :name="valueDefinition.value" autocomplete="off"> {{ valueDefinition.description }}
            </label>
        </div>
        <div class="turblatt-wrap">
            <label class="input-label">Turblatt Oberfläche</label>
            <div class="full-dropdown">
                <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle dropdown-button"
                            type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue(currentCharacteristicCode, doorLeafSurfaceContext).value.description }}<span></span>
                    </button>
                    <div class="dropdown-menu open-top" aria-labelledby="dropdownMenuButton">
                        <div class="simplebar" data-simplebar>
                            <div>
                                <a v-for="(valueDefinition, index) in doorSurfaceCharacteristicsDropDown" :key="index"
                                @click.prevent="handleDoorSurfaceOptionSelect(valueDefinition);" 
                                class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    
            <div :class="{'input-group' : true }">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Sonder Dekor / RAL Farbe / Furnier</span>
                </div>
                <input type="text" v-model="doorSurfaceSpecial" class="form-control" aria-label="Default" :disabled="doorLeafSurfaceSpecialColorAvailability"
                    aria-describedby="inputGroup-sizing-default" value="">
            </div>
        </div>
    </div> -->
</template>
<script>
import Vue from 'vue';  
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';       
import { DoorConfiguration } from '../../../configurator/DoorConfiguration';

export default Vue.extend({
    name: 'DoorLeafCounterOpeningSide',        
    props: {
            characteristic: Object,            
    },
    data() {
            return {
                doorLeafSurfaceContext : DoorConfiguration.DoorLeafSurface,
                selectedRadio : {},
                dependencies : [
                    {
                        Key : "DEKOR",
                        Value : "CUST_MM_TUEROBERFL_GBS"
                    },
                    {
                        Key : "FURNIER",
                        Value : "CUST_MM_TUEROBERFL_F_GBS",
                    },
                    {
                        Key : "LACKIERUNG",
                        Value : "CUST_MM_TUEROBERFL_L_GBS"
                    },
                ],
                doorSurfaceCharacteristicsDropDown : [],
                currentCharacteristicCode : "",
                doorSurfaceSpecialValue : '',
            }
        },
        computed : {
             ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration','getRegisteredCharacteristicsValue','getBlankCharacteristic']),
             ...mapGetters('doorLeafSurfaceModule', [ 'getCharacteristicAndValues', 'getNrOfValuesByCharacteristic', 'checkRadioValue' ]),
             doorSurfaceSpecial : {
                //getter
                get: function () {
                    this.doorSurfaceSpecialValue = this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_SO_GBS', this.doorLeafSurfaceContext).value.value;
                    return this.doorSurfaceSpecialValue;
                },
                //setter
                set : function(newValue)  {
                    this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_SO_GBS'), value: newValue });
                    this.doorSurfaceSpecialValue = newValue;
                }
            },
            // Computed property that keeps track of special value for three characteristics
            doorLeafSurfaceSpecialColorAvailability: function() {
                const _this = this; 
                let val = true;

                if (this.selectedRadio === 'DEKOR') {
                    val = _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_GBS', this.doorLeafSurfaceContext).value.value === 'LLT120060' ? false : true; 
                } else if(this.selectedRadio === 'FURNIER'){
                    val = _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_F_GBS', this.doorLeafSurfaceContext).value.value === 'LLT110022' ? false : true; 
                } else {

                    val = _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_L_GBS', this.doorLeafSurfaceContext).value.value === 'LLT130011' ? false : true;
                }
                return val;
            },
            leafSurfaceTypeOpeningSide: {
                 get: function () {
                     const _this = this;
                     return _this.getRegisteredCharacteristicsValue("KTU_MM_TOBERFL_GBS", this.doorLeafSurfaceContext).value.value;
                 },
                set: function(value) {
                }

            },
            leafSurfaceDekorOpeningSide: function() {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_TUEROBERFL_GBS", this.doorLeafSurfaceContext).value.value; 
            },
            leafSurfaceFurnierOpeningSide: function() {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_TUEROBERFL_F_GBS", this.doorLeafSurfaceContext).value.value; 
            },
            leafSurfaceLackierungOpeningSide: function() {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_TUEROBERFL_L_GBS", this.doorLeafSurfaceContext).value.value; 
            },
            leafSurfaceSpecialOpeningSide: function() {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_TUEROBERFL_SO_GBS", this.doorLeafSurfaceContext).value.value; 
            },

        },
        watch: {
            leafSurfaceTypeOpeningSide(leafSurfaceTypeOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicCounterOpeningSide();
                this.selectedRadio = _this.getRegisteredCharacteristicsValue('KTU_MM_TOBERFL_GBS', this.doorLeafSurfaceContext).value.value;
                this.currentCharacteristicCode = this.dependencies.filter((item) => item.Key === this.selectedRadio)[0].Value;
                this.doorSurfaceCharacteristicsDropDown = _this.getCharacteristicAndValues(this.currentCharacteristicCode).values;
                this.setFalzOberflacheCounterOpeningSide();
            },
            leafSurfaceDekorOpeningSide(leafSurfaceDekorOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicCounterOpeningSide();
            },
            leafSurfaceFurnierOpeningSide(leafSurfaceFurnierOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicCounterOpeningSide();
            },
            leafSurfaceLackierungOpeningSide(leafSurfaceLackierungOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicCounterOpeningSide();
            },
            leafSurfaceSpecialOpeningSide(leafSurfaceSpecialOpeningSide) {
                const _this = this;
                _this.setSchlagleisteSpecialCounterOpeningSide();
            },
            // Watcher for computed property doorLeafSurfaceSpecialColorAvailability that keeps track of special value for three characteristics
            doorLeafSurfaceSpecialColorAvailability(doorLeafSurfaceSpecialColorAvailability) {
                if (doorLeafSurfaceSpecialColorAvailability === true) {
                    this.doorSurfaceSpecial = '';
                }
            }
        },
        methods: {
            ...mapActions('configuratorModule',['updateDoorConfiguration']),
            ...mapActions('doorLeafSurfaceModule', ['addCharacterisitc','valueAddCharacteristic', 'calculateDoorLeafSurfaceDekorCounterOpeningSide',
                          'calculateDoorLeafSurfaceLackierungCounterOpeningSide',
                          'calculateDoorLeafSurfaceFurnierCounterOpeningSide',
                          'setSchlagleisteDependantCharacteristicCounterOpeningSide', 'setSchlagleisteSpecialCounterOpeningSide','setFalzOberflacheCounterOpeningSide']),
            handleRadioSelect(characteristic, valueDefinition) {
                const _this = this;
                this.selectedRadio = characteristic.valueDefinition.value;
                this.initializeDoorSurfaceChars();
                this.currentCharacteristicCode = this.dependencies.filter((item) => item.Key === this.selectedRadio)[0].Value;
                // const characteristicsWithEmptyValue = this.dependencies.filter((item) => item.Key !== this.selectedRadio);
                //
                // characteristicsWithEmptyValue.forEach(element => {
                //     const val = _this.getCharacteristicAndValues(element.Value).values.filter((item) => item.value === '0' )[0];
                //     _this.addCharacterisitc({ characteristic: _this.getCharacteristicAndValues(element.Value), valueDefinition: val });
                // });

                this.doorSurfaceCharacteristicsDropDown = _this.getCharacteristicAndValues(this.currentCharacteristicCode).values;

                this.setFalzOberflacheCounterOpeningSide();

                this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_FURNIEROBERFL_GBS");
                this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_GLANZGRAD_GBS");

                // this.doorSurfaceInputEnabled = false;
                // this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_SO_GBS'), value: 0 });
            },
            handleDoorSurfaceOptionSelect(valueDefinition) {  
                const _this = this;               
                _this.addCharacterisitc({ characteristic: _this.getCharacteristicAndValues(this.currentCharacteristicCode), valueDefinition: valueDefinition });

                if(this.selectedRadio === "DEKOR") {
                    _this.calculateDoorLeafSurfaceDekorCounterOpeningSide();
                }
                else if (this.selectedRadio === 'LACKIERUNG') {
                    _this.calculateDoorLeafSurfaceLackierungCounterOpeningSide();
                }
                else if (this.selectedRadio === 'FURNIER') {
                    _this.calculateDoorLeafSurfaceFurnierCounterOpeningSide();
                }
                this.setFalzOberflacheCounterOpeningSide();
                //  if(this.specialCharacteristicLLTNumber === valueDefinition.value){
                //      this.doorSurfaceInputEnabled = true;
                //  }else {
                //      this.doorSurfaceInputEnabled = false;
                //      this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_SO_GBS'), value: 0 });
                //  }
            },
            initializeDoorSurfaceChars() {
                let selectFurnierValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_GBS').values;
                let selectLackierungValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_GBS').values;
                let selectDekorValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_GBS').values;

                let selectedFurnierValue = this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_F_GBS', this.doorLeafSurfaceContext).value.value
                let selectedLackierungValue = this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_L_GBS', this.doorLeafSurfaceContext).value.value
                let selectedDekorValue = this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_GBS', this.doorLeafSurfaceContext).value.value

                if(this.selectedRadio === 'DEKOR'){
                    let LLTToSetDekor = selectedLackierungValue === 0 ? 'LLT120073' : selectedDekorValue
                    let valueToSetDekor = selectDekorValues.find(x => x.value === LLTToSetDekor);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_GBS'), valueDefinition: valueToSetDekor });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_GBS'), valueDefinition: valueToSetLackierung });
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_GBS'), valueDefinition: valueToSetFurnier });
                }
                else if (this.selectedRadio === 'FURNIER') {
                    let valueToSetDekor = selectDekorValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_GBS'), valueDefinition: valueToSetDekor });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_GBS'), valueDefinition: valueToSetLackierung });
                    let LLTToSetFurnier = selectedLackierungValue === 0 ? 'LLT110001' : selectedFurnierValue
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === LLTToSetFurnier);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_GBS'), valueDefinition: valueToSetFurnier });
                }
                else if (this.selectedRadio === 'LACKIERUNG') {
                    let LLTToSetDekor = selectedLackierungValue === 0 ? 'LLT120077' : selectedDekorValue
                    let valueToSetDekor = selectDekorValues.find(x => x.value === LLTToSetDekor);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_GBS'), valueDefinition: valueToSetDekor });
                    let LLTToSetLackierung = selectedLackierungValue === 0 ? 'LLT130010' : selectedLackierungValue
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === LLTToSetLackierung);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_GBS'), valueDefinition: valueToSetLackierung });
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_GBS'), valueDefinition: valueToSetFurnier });
                }
            },
        },
         mounted() {
            const _this = this;
            this.selectedRadio = _this.getRegisteredCharacteristicsValue('KTU_MM_TOBERFL_GBS', this.doorLeafSurfaceContext).value.value;
            this.currentCharacteristicCode = this.dependencies.filter((item) => item.Key === this.selectedRadio)[0].Value;
            this.doorSurfaceCharacteristicsDropDown = _this.getCharacteristicAndValues(this.currentCharacteristicCode).values;
            this.initializeDoorSurfaceChars()
             const isAvailable = this.doorLeafSurfaceSpecialColorAvailability
             if (isAvailable)
                 this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_SO_GBS'), value: "" })
             this.setFalzOberflacheCounterOpeningSide();

             // this.blankCharacteristic = this.getBlankCharacteristic;
            // if(this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_SO_GBS', this.doorLeafSurfaceContext).value.value != 0){
            //     this.doorSurfaceInputEnabled = true;
            // }
        }


});

</script>